module.exports = __webpack_public_path__ + "assets/static/png/mypayments-red.317026783789d1e697ea1fb5e7046e9c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/mypayments-red.png
 ** module id = 512
 ** module chunks = 1
 **/